import { render, staticRenderFns } from "./Brief-Form.vue?vue&type=template&id=37d40c60"
import script from "./Brief-Form.vue?vue&type=script&lang=js"
export * from "./Brief-Form.vue?vue&type=script&lang=js"
import style0 from "./Brief-Form.vue?vue&type=style&index=0&id=37d40c60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports